<template>
<router-view />
</template>

<script>
export default {
  name: 'StatisticalAnalysisSiteCompare',
  routeInfo: {
    label: '站点比对分析',
    icon: 'fa fa-line-chart'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/05Site-Compare/index.vue